export default __webpack_public_path__ + "static/media/fotoFondo.1db84c25.png";